import { InternalArpMetadata, MintStatusModel } from '@arpeggi/shared'
import { useAuth } from '../../../__legacy__/hooks/useAuth'
import { objectToFormData } from '../../../__legacy__/utils/api'

interface UploadedSongCreateDto {
  coverImage?: File
  soundFile: File
  soundDto: {
    subcomponents: number[]
    metadata: Omit<InternalArpMetadata, 'tags'>
  }
  walletAddress?: string
}

export const useMintsAPI = () => {
  const { authenticatedPost } = useAuth()

  const uploadedSongCreate = async (dto: UploadedSongCreateDto) => {
    const { data } = await authenticatedPost<MintStatusModel>(
      '/api/v2/mints/uploaded-songs',
      objectToFormData(dto)
    )

    return data
  }

  return { uploadedSongCreate }
}
